export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "GET";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Patch"] = "PATCH";
})(HttpMethod || (HttpMethod = {}));
export var RejectionErrorTypes;
(function (RejectionErrorTypes) {
    RejectionErrorTypes["Server"] = "SERVER";
    RejectionErrorTypes["Application"] = "APPLICATION";
    RejectionErrorTypes["Network"] = "NETWORK";
    RejectionErrorTypes["InvalidJson"] = "INVALID_JSON";
    RejectionErrorTypes["AccessionNotFound"] = "ACCESSION_NOT_FOUND";
    RejectionErrorTypes["SurveyCompleted"] = "SURVEY_COMPLETED";
    RejectionErrorTypes["SurveyAccountIdNotFound"] = "SURVEY_ACCOUNT_ID_NOT_FOUND";
    RejectionErrorTypes["MissingAccount"] = "MISSING_ACCOUNT";
})(RejectionErrorTypes || (RejectionErrorTypes = {}));
export var RecoverTypes;
(function (RecoverTypes) {
    RecoverTypes["Restart"] = "RESTART";
    RecoverTypes["GoBack"] = "GO_BACK";
    RecoverTypes["None"] = "NONE";
})(RecoverTypes || (RecoverTypes = {}));
